export function validateLatitude(latitude: string | undefined) {
    if (!latitude) {
        return;
    }
    if (parseFloat(latitude) < -90) {
        return 'Cannot be less than -90';
    }
    if (parseFloat(latitude) > 90) {
        return 'Cannot be greater than 90';
    }
}

export function validateLongitude(longitude: string | undefined) {
    if (!longitude) {
        return;
    }
    if (parseFloat(longitude) < -180) {
        return 'Cannot be less than -180';
    }
    if (parseFloat(longitude) > 180) {
        return 'Cannot be greater than 180';
    }
}
